import React from "react";
var Icon = function Icon(_ref) {
    var iconName = _ref.iconName, color = _ref.color, className = _ref.className, tooltip = _ref.tooltip;
    var icon;
    var tip;
    if (color === undefined)
        color = "#ff5b00";
    var currentColor = color === "current-color";
    if (iconName === IconName.BOOKMARK) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "nonzero",
            strokeLinejoin: "round",
            strokeMiterlimit: "2",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M80 39.802c0 22.08-17.92 40-40 40s-40-17.92-40-40 17.92-40 40-40 40 17.92 40 40",
            fill: color,
            className: currentColor ? "fill-current" : ""
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M56 16.78H24v45.77l16-13.77 16 13.77V16.78z",
            fill: "#fff"
        }));
    }
    else if (iconName === IconName.SHARE) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "evenodd",
            className: className
        }, /*#__PURE__*/ React.createElement("g", {
            fillRule: "nonzero"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M80 40c0 22.08-17.92 40-40 40S0 62.08 0 40 17.92 0 40 0s40 17.92 40 40",
            fill: color
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M19.9 46.3c3.632 0 6.58-2.827 6.58-6.312s-2.947-6.3-6.58-6.3-6.58 2.824-6.58 6.3S16.277 46.3 19.9 46.3m32.9-18.06c3.632 0 6.58-2.827 6.58-6.3 0-3.488-2.947-6.312-6.58-6.312s-6.58 2.824-6.58 6.312c0 3.483 2.947 6.3 6.58 6.3m0 36.124c3.632 0 6.58-2.827 6.58-6.312s-2.947-6.3-6.58-6.3-6.58 2.824-6.58 6.3 2.947 6.312 6.58 6.312",
            fill: "#fff"
        })), /*#__PURE__*/ React.createElement("g", {
            fill: "none",
            stroke: "#fff"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M20.3 39.007l32.112-16.072",
            strokeWidth: "4.747"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M20.3 40.994l32.112 16.072",
            strokeWidth: "4.773"
        })));
    }
    else if (iconName === IconName.PDF) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "nonzero",
            strokeLinejoin: "round",
            strokeMiterlimit: "2",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M80 40c0 22.08-17.92 40-40 40S0 62.08 0 40 17.92 0 40 0s40 17.92 40 40",
            fill: color
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M55.24 59.428V16.793H35.963L24.76 27.996v31.432h30.48z",
            fill: "#fff"
        }));
    }
    else if (iconName === IconName.LOGIN) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: "2",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M80 39.802c0 22.08-17.92 40-40 40s-40-17.92-40-40 17.92-40 40-40 40 17.92 40 40",
            fill: color,
            fillRule: "nonzero",
            className: currentColor ? "fill-current" : ""
        }), /*#__PURE__*/ React.createElement("g", {
            fill: "#fff"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M28.7 18.638h27.1v7.125H28.7zm0 33.9h27.1v7.125H28.7z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M48.648 19.2h7.125v39.93h-7.125z"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M11.07 33v13.333h13.333l10.667-6.667L24.404 33H11.07z",
            fillRule: "nonzero"
        })));
    }
    else if (iconName === IconName.SEARCH) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "nonzero",
            strokeLinejoin: "round",
            strokeMiterlimit: "2",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M80 39.802c0 22.08-17.92 40-40 40s-40-17.92-40-40 17.92-40 40-40 40 17.92 40 40",
            fill: color,
            className: currentColor ? "fill-current" : ""
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M47.848 43.45l-.168.22c1.725-2.448 2.728-5.34 2.728-8.57 0-8.35-6.736-15.085-15.085-15.085A15.06 15.06 0 0 0 20.24 35.099a15.06 15.06 0 0 0 15.083 15.085c3.23 0 6.123-1.003 8.573-2.784l-.224.277L55.528 59.6l4.232-4.23L47.848 43.45z",
            fill: "#fff"
        }));
    }
    else if (iconName === IconName.MENU) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: "2",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M80 39.802c0 22.08-17.92 40-40 40s-40-17.92-40-40 17.92-40 40-40 40 17.92 40 40",
            fill: color,
            fillRule: "nonzero",
            className: currentColor ? "fill-current" : ""
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M20.704 20.022h38.58v6.883h-38.58zm0 16.408h38.58v6.883h-38.58zm0 16.288h38.58V59.6h-38.58z",
            fill: "#fff"
        }));
    }
    else if (iconName === IconName.AUDIO) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "evenodd",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M80 39.802c0 22.08-17.92 40-40 40s-40-17.92-40-40 17.92-40 40-40 40 17.92 40 40",
            fill: color,
            className: currentColor ? "fill-current" : "",
            fillRule: "nonzero"
        }), /*#__PURE__*/ React.createElement("g", {
            fill: "none",
            stroke: "#fff",
            strokeWidth: "4.192"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M20.677 50.995V38.732c0-10.09 8.723-18.396 19.323-18.396s19.323 8.305 19.323 18.396v12.264"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M59.323 53.04c0 2.242-1.94 4.088-4.294 4.088h-2.147c-2.355 0-4.294-1.846-4.294-4.088v-6.132c0-2.242 1.94-4.088 4.294-4.088h6.44v10.22zm-38.646 0c0 2.242 1.94 4.088 4.294 4.088h2.147c2.355 0 4.294-1.846 4.294-4.088v-6.132c0-2.242-1.94-4.088-4.294-4.088h-6.44v10.22z"
        })));
    }
    else if (iconName === IconName.CLOSE) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 24 24",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M18 6L6 18",
            stroke: color,
            className: currentColor ? "fill-current" : ""
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M6 6l12 12",
            stroke: color,
            className: currentColor ? "fill-current" : ""
        }));
    }
    else if (iconName === IconName.MAGNIFIER) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "100%",
            height: "100%",
            viewBox: "0 0 80 80",
            fillRule: "evenodd",
            strokeLinejoin: "round",
            strokeMiterlimit: "2",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M55.376 47.143l-.327.436c3.38-4.798 5.343-10.47 5.343-16.793A29.51 29.51 0 0 0 30.84 1.233 29.51 29.51 0 0 0 1.287 30.786 29.51 29.51 0 0 0 30.84 60.338c6.325 0 11.995-1.963 16.793-5.452l-.436.545 23.228 23.337 8.288-8.288-23.337-23.337z",
            fill: color,
            fillRule: "nonzero"
        }));
    }
    else if (iconName === IconName.EXPAND) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            focusable: "false",
            "data-prefix": "fas",
            "data-icon": "expand-alt",
            role: "img",
            viewBox: "0 0 448 512",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            fill: color,
            d: "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
        }));
    }
    else if (iconName === IconName.DELETE) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            fill: color,
            d: "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        }));
    }
    else if (iconName === IconName.FACEBOOK) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            fill: color,
            d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
        }));
    }
    else if (iconName === IconName.TWITTER) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            fill: color,
            d: "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
        }));
    }
    else if (iconName === IconName.EMAIL) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 512",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            fill: color,
            d: "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805l-134.587 106.49c-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701L48 152.805V112h416zM48 400V214.398l104.938 82.646c21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947L464 214.399V400H48z"
        }));
    }
    else if (iconName === IconName.WHATSAPP) {
        icon = /*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            className: className
        }, /*#__PURE__*/ React.createElement("path", {
            fill: color,
            d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6z"
        }));
    }
    if (tooltip) {
        tip = /*#__PURE__*/ React.createElement("span", {
            className: "tooltip absolute hidden z-0 text-xs whitespace-no-wrap -mr-2 pl-2 pr-3 rounded-l",
            style: {
                top: "50%",
                right: "100%",
                marginTop: "-10px",
                paddingBottom: "2px",
                backgroundColor: "rgba(221,221,221,0.8)"
            }
        }, tooltip);
    }
    var getTooltipElement = function getTooltipElement(id) {
        var elements = document.getElementById(id).getElementsByClassName("tooltip");
        if (elements && elements.length > 0) {
            return elements[0];
        }
    };
    var showTooltip = function showTooltip(id) {
        var elem = getTooltipElement(id);
        if (elem) {
            elem.classList.remove("hidden");
            elem.classList.add("block");
        }
    };
    var hideTooltip = function hideTooltip(id) {
        var elem = getTooltipElement(id);
        if (elem) {
            elem.classList.remove("block");
            elem.classList.add("hidden");
        }
    };
    var randomId = "_" + Math.random().toString(36).substr(2, 9);
    return /*#__PURE__*/ React.createElement("div", {
        id: randomId,
        className: "relative makroIcon"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative z-10",
        onMouseEnter: function onMouseEnter() {
            return showTooltip(randomId);
        },
        onMouseLeave: function onMouseLeave() {
            return hideTooltip(randomId);
        },
        onMouseDown: function onMouseDown() {
            return hideTooltip(randomId);
        }
    }, icon), tip);
};
export default Icon;
export var IconName;
(function (IconName) {
    IconName[IconName["BOOKMARK"] = 0] = "BOOKMARK";
    IconName[IconName["SHARE"] = 1] = "SHARE";
    IconName[IconName["PDF"] = 2] = "PDF";
    IconName[IconName["LOGIN"] = 3] = "LOGIN";
    IconName[IconName["SEARCH"] = 4] = "SEARCH";
    IconName[IconName["MENU"] = 5] = "MENU";
    IconName[IconName["AUDIO"] = 6] = "AUDIO";
    IconName[IconName["CLOSE"] = 7] = "CLOSE";
    IconName[IconName["MAGNIFIER"] = 8] = "MAGNIFIER";
    IconName[IconName["EXPAND"] = 9] = "EXPAND";
    IconName[IconName["DELETE"] = 10] = "DELETE";
    IconName[IconName["FACEBOOK"] = 11] = "FACEBOOK";
    IconName[IconName["TWITTER"] = 12] = "TWITTER";
    IconName[IconName["EMAIL"] = 13] = "EMAIL";
    IconName[IconName["WHATSAPP"] = 14] = "WHATSAPP";
})(IconName || (IconName = {}));
